<template>
  <div style="border: 1px solid #ccc" class="relative" v-loading="loading" :element-loading-text="loadTxt">
    <div v-if="disabled" class="disable-layer" />
    <Toolbar ref="toolbar" style="border-bottom: 1px solid #ccc;display:block;" :editor="editor" :default-config="toolbarConfig" :mode="mode" />
    <Editor class="editor-cont" style="overflow-y: hidden;height: 300px;display: block;font-size: 14px;" :index="index" placeholder="placeholder" :value="value" :default-config="editorConfig" :mode="mode" @input="handleInput" @onCreated="onCreated" @onChange="onChange"/>
  </div>
</template>
 
<script>
// 引入包
import axios from "axios"
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getUploadToken} from "@/assets/js/api";
import '@wangeditor/editor/dist/css/style.css'
export default {
  name: 'WangEditor',
  components: { Editor, Toolbar },
  props: {
    value: String,
    disabled: Boolean,
    cusHeight: {
      type: String,
      default: '150px'
    },
    index:Number
  },
  data() {
    const vm = this;
    return {
      serverUrl:'',
      editor: null,
      vueInstance: null, 
      html: '',
      uploadObj: {
        token: "",
        key: "",
        file:''
      },

      loading:false,
      loadTxt:'',
      // wangeditor/editor-for-vue的配置
      toolbarConfig: {
        toolbarKeys: [
          'bold',
          'underline',
          'italic',
          'through',
          'clearStyle',
          'color',
          'bgColor',
          'fontSize',
          // 'fontFamily',
          'justifyLeft',
          'justifyRight',
          'justifyCenter',
          'justifyJustify',
          'lineHeight',
          // 'header1',
          // 'header2',
          // 'header3',
          // 'header4',
          // 'header5',
          // 'bulletedList',
          // 'numberedList',
          'uploadImage'
          // "uploadVideo"
        ]
      },
      editorConfig: {
        placeholder: '请输入文本',
        MENU_CONF: {
          uploadImage: {
            // ✅ 使用普通函数确保 this 指向 Vue 组件
            customUpload: function(file, insertFn) {
              // 文件类型验证
              const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
              if (!allowedTypes.includes(file.type)) {
                vm.$message.error('仅支持 JPG、PNG、GIF、WEBP 格式图片');
                return;
              }
              
              // 文件大小验证（5MB）
              const maxSize = 5 * 1024 * 1024;
              if (file.size > maxSize) {
                vm.$message.error('图片大小不能超过 5MB');
                return;
              }
              
              vm.$emit('imgUpload', '1');
              vm.loading = true;
              vm.loadTxt = '请稍后...';
              // ✅ 构建七牛云要求的 FormData：token + key + file
              const form = new FormData();
              form.append('token', vm.uploadObj.token);
              form.append('key', file.name);
              form.append('file', file); // file 本身就是二进制 File 对象，直接 append
              vm.$message.success('上传中，请稍后');
              axios({
                url: 'https://up-as0.qiniup.com',
                data: form,
                method: 'post',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
              }).then((arr) => {
                console.log(arr, 'artt');
                const url = 'https://speakiopic.zens10.com/' + arr.data.key;
                insertFn(url, file.name, url);
                vm.$message.success('上传成功');
                vm.loading = false;
                vm.loadTxt = '';
              })
              .catch((error) => {
                console.log(error);
                vm.loading = false;
                vm.loadTxt = '';
              })
              .finally(() => {
                vm.$emit('imgUpload', '0');
              });
            }
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  mounted() {
    var url = '';
    if(window.location.origin == 'https://speakioweb.zens10.com'){
      url = 'https://speakio.zens10.com/'
    } else {
      url = 'https://speakios.zens10.com/'
    };
    this.serverUrl = url;
    this.getToken();
  },
  created() {},
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      // console.log('this.editor :>> ', this.editor.getAllMenuKeys());
    },
    handleInput(value) {
      // 将文本内容传给父组件（引用这个组件的vue文件的）
      // console.log(value.indexOf('<div style="word-break: break-word;">'),'==33333==')
      // value = '<div style="word-break: break-word;">' + value + '</div>'
      value = value.replaceAll('<p>','<p style="word-break: break-word;">');
      console.log(value,this.index,'val')
      this.$emit('input', value,this.index)
    },

    onChange(editor) {
      const text = editor.getHtml()
      this.$emit('update:content', text)
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },
  }
}
</script>

<style>
  .relative{
    width: 80%;
  }

  .relative p{
    display: block;
    padding: 0;
  }
  .w-e-text-placeholder{
    font-size: 14px;
  }

  h1{
    font-size: 50px;
  }
  h2{
    font-size: 40px;
  }
  h3{
    font-size: 30px;
  }
  h4{
    font-size: 20px;
  }
  h5{
    font-size: 10px;
  }
</style>
 



// WEBPACK FOOTER //
// src/components/comment/wangeditor.vue